import React from "react";
import { Button } from "reactstrap";
import { useNavigate } from "react-router";

function TotalCart({ args, total }) {
  const navigate = useNavigate();

  return (
    <div className="w-25">
      <div className="total_ship">
        <div className="border_bottom_pay p-3">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <span className="fs-20">Subtotal</span>
            <span className="fs-20 fw-bold">
              {(total * 1).toLocaleString("vi")}&#273;
            </span>
          </div>

          <div className="d-flex justify-content-between align-items-center">
            <span className="fs-20">Shipping</span>
            <span className="fs-20 fw-bold">Free</span>
          </div>
        </div>

        <div className="d-flex justify-content-between align-items-center mb-2 p-3">
          <span className="fs-20 fw-bold">TOTAL</span>
          <span className="fs-20 fw-bold t-primary">
            {(total * 1).toLocaleString("vi")}&#273;
          </span>
        </div>
      </div>

      <div className="d-flex justify-content-center">
        <Button className="btn_custom mt-2" onClick={() => navigate("/pay")}>
          Pay
        </Button>
      </div>
    </div>
  );
}

export default TotalCart;
